<template>
  <FlagStatus
    :flags="props.params.value"
    class="h-full w-full"
  />
</template>

<script setup>
import FlagStatus from '@/Components/Flags/FlagStatus.vue'

/**
 * @typedef {Object} FlaggedCellParams
 * @param {Array} value
 */
const props = defineProps({
  /** @type {FlaggedCellParams} */
  params: {
    type: Object,
    required: true
  }
})
</script>
